import types from './types';

const defaultState = {
  initialData: null
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */, // request is not a http, it's accessRequestDto
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_ACCESS_REQUEST_INITIAL_DATA:
      return { ...state, isLoading: true };
    case types.GET_ACCESS_REQUEST_INITIAL_DATA_SUCCESS:
      return { ...state, initialData: data, isLoading: false };
    case types.GET_ACCESS_REQUEST_INITIAL_DATA_FAILURE:
      return { ...state, isLoading: false };

    case types.NEW_ACCESS_REQUEST:
      return { ...state, isLoading: true };
    case types.NEW_ACCESS_REQUEST_SUCCESS:
    case types.NEW_ACCESS_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        requestStatus: action.response.request.status,
        isAccepted: data,
        accessRequestDto: request?.params?.accessRequestDto
      };

    default:
      return state;
  }
};
